import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Alert,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Dimensions,
  ActivityIndicator,
  Modal
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Ionicons, FontAwesome5 } from '@expo/vector-icons';
import * as ImagePicker from 'expo-image-picker';
import * as FileSystem from 'expo-file-system';
import Tesseract from 'tesseract.js';
import { API_BASE_URL } from '../config/api';
import Constants from "expo-constants";
// Note: Registration endpoint not documented in current API specification
// import { registerUser } from '../services/authApi';
import { useFocusEffect } from '@react-navigation/native';
import '../styles/custom.css';

import DropDownPicker from 'react-native-dropdown-picker';
import DateTimePicker, { DateType, useDefaultStyles } from 'react-native-ui-datepicker';
import { MaskedTextInput } from "react-native-mask-text";
import { useFonts } from 'expo-font';
import * as DatePickerStyle from '../styles/datepicker.js';
import * as DropdownStyle from '../styles/dropdown.js';
import { useCustomAlertModal } from '../components/CustomAlertModal';
import TurnstileWidget from '../components/TurnstileWidget';

const { width, height } = Dimensions.get('window');

export default function RegisterScreen({ navigation }) {
  const { 
    customAlertModal, 
    showCustomAlert, 
    hideCustomAlert, 
    handleCustomAlertConfirm
  } = useCustomAlertModal();

  const dmyPattern = /^\d{2}-\d{2}-\d{4}$/;
  const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    birthDate: '',
    placeOfBirth: '',
    nik: '',
    password: '',
    confirmPassword: '',
    identityFile: null,
    province: '',
    city: '',
    address: '',
    gender: '',
  });
  const [ocrData, setOcrData] = useState({
    fullName: '',
    birthDate: '',
    placeOfBirth: '',
    nik: '',
    gender: '',
    province: '',
    city: ''
  });
  const [isLoadSettings, setIsLoadSettings] = useState(false);
  const [isKTPRequired, setIsKTPRequired] = useState(true);
  const [minAge, setMinAge] = useState("21");

  const [genders, setGenders] = useState([
    {label: 'Laki-Laki', value: 'LAKI-LAKI'},
    {label: 'Perempuan', value: 'PEREMPUAN'},
  ]);
  const [isGenderOpen, setIsGenderOpen] = useState(false);

  const [isLoadProvinces, setIsLoadProvinces] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [isProvinceOpen, setIsProvinceOpen] = useState(false);

  const [isLoadCities, setIsLoadCities] = useState(false);
  const [cities, setCities] = useState([]);
  const [isCityOpen, setIsCityOpen] = useState(false);
  const [ocrCity, setOcrCity] = useState('');

  const [openDropdown, setOpenDropdown] = useState('');

  const [currentProvince, setCurrentProvince] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [ageConfirmation, setAgeConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [isProcessingOCR, setIsProcessingOCR] = useState(false);
  const [isFieldEditable, setIsFieldEditable] = useState(false);

  const [googleButtonClicked, setGoogleButtonClicked] = useState(false);
  const [facebookButtonClicked, setFacebookButtonClicked] = useState(false);
  const [appleButtonClicked, setAppleButtonClicked] = useState(false);

  const datepickerDefaultStyles = useDefaultStyles();
  const [datepickerDate, setDatepickerDate] = useState(new Date());
  const [isDatepickerShown, setIsDatepickerShown] = useState(false);

  const [captchaToken, setCaptchaToken] = useState(null);

  const hideDatePicker = () => {
    setIsDatepickerShown(false);
  }

  const handleShowDatepicker = (date = null) => {
    if (date instanceof Date) {
      setDatepickerDate( date );
    } else if (typeof date === 'string') {
      let selectedDate = new Date();

      if( ymdPattern.test(date) ) selectedDate = new Date(date);
      else if(dmyPattern.test(date)) {
        const parts = date.split('-');
        selectedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      }

      // handle user giving invalid number string
      if(isNaN(selectedDate.getTime())) {
        if( date == formData.birthDate ) {
          handleInputChange('birthDate', '');
        }
        selectedDate = new Date();
      }

      setDatepickerDate(selectedDate);
    } else {
      setDatepickerDate( new Date() );
    }

    setIsDatepickerShown(true);
  }

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const processOCRKTP = async (base64KTP) => {
    try {
      setIsProcessingOCR(true);
      console.log('Processing KTP image with OCR...');

      // Call the documented /api/v1/createsso endpoint
      const response = await fetch(`${API_BASE_URL}/api/v1/ocr-identity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY ||
            "9f3c7a2d1b84e6f5c0a9d27e4b6f8a1c5d3e9b7a0c2f4e6d8a1b3c5f7e9d2",
        },
        body: JSON.stringify({
          "identity-number": "",
          "identity-file": base64KTP,
        }),
      });

      const result = await response.json();

      if (result.status !== "success") {
        setIsFieldEditable(false);
        setUploadedFileName('');
        showCustomAlert(
          'Informasi',
          'Data KTP tidak dapat dibaca dengan jelas atau tidak sesuai format yang valid.\n\nSilakan:\n1. Pastikan foto KTP jelas dan tidak buram\n2. Pastikan pencahayaan cukup\n3. Isi form secara manual jika diperlukan'
        );
      } else {

        // console.log('OCR Result:', result.data);

        // Validation rules before filling form
        let validDataCount = 0;
        let filledFields = [];
        let validatedData = {};

        const ocrIdentityData = result.data;
        validatedData.nik = ocrIdentityData.number;
        validDataCount++;
        filledFields.push('NIK');

        validatedData.fullName = ocrIdentityData.name;
        validDataCount++;
        filledFields.push('Nama');

        validatedData.placeOfBirth = ocrIdentityData.place;
        validDataCount++;
        filledFields.push('Tempat Lahir');

        if( dmyPattern.test(ocrIdentityData.dob) ) {
          validatedData.birthDate = ocrIdentityData.dob;
          validDataCount++;
          filledFields.push('Tanggal Lahir');
        }

        validatedData.province = '';
        if( provinces.map(p => p.value).includes(ocrIdentityData.province?.toUpperCase()) ) {
          validatedData.province = ocrIdentityData.province?.toUpperCase();
          validDataCount++;
          filledFields.push('Provinsi');
        }

        validatedData.city = '';
        setOcrCity(ocrIdentityData.city?.toUpperCase());
        validDataCount++;
        filledFields.push('Kab/Kota');

        validatedData.address = ocrIdentityData.address;
        validDataCount++;
        filledFields.push('Alamat Detail');

        validatedData.gender = ocrIdentityData.gender?.toUpperCase();
        validDataCount++;
        filledFields.push('Jenis Kelamin');

        setOcrData(prev => ({
          ...prev,
          ...validatedData,
          city: ocrIdentityData.city?.toUpperCase()
        }));

        // Pre-fill form with validated data
        if (validDataCount > 0) {
          setFormData(prev => ({
            ...prev,
            ...validatedData
          }));

          setIsFieldEditable(true);

          showCustomAlert(
            'KTP Berhasil Dipindai',
            `Data KTP berhasil dipindai!\n\nField yang terisi: ${filledFields.join(', ')}\n\nSilakan periksa dan lengkapi data yang masih kosong.`,
            'success'
          );
        } else {
          setIsFieldEditable(false);
          setUploadedFileName('');
          showCustomAlert(
            'Informasi',
            'Data KTP tidak dapat dibaca dengan jelas atau tidak sesuai format yang valid.\n\nSilakan:\n1. Pastikan foto KTP jelas dan tidak buram\n2. Pastikan pencahayaan cukup\n3. Isi form secara manual jika diperlukan'
          );
        }
      }
    } catch (error) {
      console.error('OCR Error:', error);
      setUploadedFileName('');
      showCustomAlert(
        'Gagal Memindai KTP',
        'Tidak dapat membaca data dari KTP. Silakan isi form secara manual.'
      );
    } finally {
      setIsProcessingOCR(false);
    }
  };

  const processKTPImage = async (imageUri) => {
    try {
      setIsProcessingOCR(true);
      console.log('Processing KTP image with OCR...');

      const { data: { text } } = await Tesseract.recognize(
        imageUri,
        'ind+eng', // Indonesian and English language
        {
          logger: m => {
            if (m.status === 'recognizing text') {
              console.log(`OCR Progress: ${Math.round(m.progress * 100)}%`);
            }
          }
        }
      );

      console.log('OCR Result:', text);

      // Extract information from OCR text
      const extractedData = extractKTPData(text);

      // Validation rules before filling form
      let validDataCount = 0;
      let filledFields = [];
      let validatedData = {};

      // Only fill fields if data passes validation
      if (extractedData.nik && /^\d{15,16}$/.test(extractedData.nik)) {
        validatedData.nik = extractedData.nik;
        validDataCount++;
        filledFields.push('NIK');
      }

      if (extractedData.fullName && /^[A-Za-z\s]{2,}$/.test(extractedData.fullName)) {
        validatedData.fullName = extractedData.fullName;
        validDataCount++;
        filledFields.push('Nama');
      }

      if (extractedData.placeOfBirth && /^[A-Za-z\s]{2,}$/.test(extractedData.placeOfBirth)) {
        validatedData.placeOfBirth = extractedData.placeOfBirth;
        validDataCount++;
        filledFields.push('Tempat Lahir');
      }

      if (extractedData.birthDate && /^\d{2}-\d{2}-\d{4}$/.test(extractedData.birthDate)) {
        // Additional date validation
        const dateParts = extractedData.birthDate.split('-');
        const day = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]);
        const year = parseInt(dateParts[2]);
        const date = new Date(year, month - 1, day);
        const currentDate = new Date();
        if (date < currentDate && year >= 1900) {
          validatedData.birthDate = extractedData.birthDate;
          validDataCount++;
          filledFields.push('Tanggal Lahir');
        }
      }

      // Pre-fill form with validated data
      if (validDataCount > 0) {
        setFormData(prev => ({
          ...prev,
          ...validatedData
        }));

        showCustomAlert(
          'KTP Berhasil Dipindai',
          `Data KTP berhasil dipindai!\n\nField yang terisi: ${filledFields.join(', ')}\n\nSilakan periksa dan lengkapi data yang masih kosong.`,
          'success'
        );
      } else {
        showCustomAlert(
          'Informasi',
          'Data KTP tidak dapat dibaca dengan jelas atau tidak sesuai format yang valid.\n\nSilakan:\n1. Pastikan foto KTP jelas dan tidak buram\n2. Pastikan pencahayaan cukup\n3. Isi form secara manual jika diperlukan'
        );
      }
    } catch (error) {
      console.error('OCR Error:', error);
      showCustomAlert(
        'Gagal Memindai KTP',
        'Tidak dapat membaca data dari KTP. Silakan isi form secara manual.'
      );
    } finally {
      setIsProcessingOCR(false);
    }
  };

  const extractKTPData = (text) => {
    const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
    const extractedData = {};

    console.log('Processing lines:', lines);
    console.log('Full OCR text:', text);

    try {
      // Search for NIK pattern anywhere in the text (more flexible approach)
      // Handle OCR artifacts like 'b' being misread as part of NIK
      const nikPattern = /NIK\s*:?\s*[a-zA-Z]?(\d{15,16})/i;
      const nikMatch = text.match(nikPattern);
      if (nikMatch && (nikMatch[1].length === 15 || nikMatch[1].length === 16)) {
        // If 15 digits, pad with leading zero to make it 16
        extractedData.nik = nikMatch[1].length === 15 ? '0' + nikMatch[1] : nikMatch[1];
        console.log('Found NIK:', extractedData.nik);
      }

      // Alternative NIK pattern - sometimes OCR misreads characters
      if (!extractedData.nik) {
        const altNikPattern = /\b[a-zA-Z]?(\d{15,16})\b/;
        const altNikMatch = text.match(altNikPattern);
        if (altNikMatch && (altNikMatch[1].length === 15 || altNikMatch[1].length === 16)) {
          extractedData.nik = altNikMatch[1].length === 15 ? '0' + altNikMatch[1] : altNikMatch[1];
          console.log('Found NIK (alternative):', extractedData.nik);
        }
      }

      // Even more flexible NIK search - look for any 15-16 digit sequence
      if (!extractedData.nik) {
        const flexNikPattern = /(\d{15,16})/;
        const flexNikMatch = text.match(flexNikPattern);
        if (flexNikMatch && (flexNikMatch[1].length === 15 || flexNikMatch[1].length === 16)) {
          extractedData.nik = flexNikMatch[1].length === 15 ? '0' + flexNikMatch[1] : flexNikMatch[1];
          console.log('Found NIK (flexible):', extractedData.nik);
        }
      }

      // Search for Name pattern anywhere in the text
      const namePattern = /Nama\s*:?\s*([A-Z\s]{2,50})/i;
      const nameMatch = text.match(namePattern);
      if (nameMatch) {
        let name = nameMatch[1].trim();
        // Clean up the name - remove extra characters and normalize
        name = name.replace(/[^A-Za-z\s]/g, '').trim();
        name = name.replace(/\s+/g, ' '); // normalize spaces

        if (/^[A-Z\s]+$/i.test(name) && name.length >= 2 && name.length <= 50) {
          extractedData.fullName = name.toUpperCase();
          console.log('Found Name:', name);
        }
      }

      // Search for Birth place and date pattern - handle various OCR variations
      // Handle 'TgiLahir' and other OCR misreadings
      const birthPattern = /Tempat[\/\s]*T[a-z]*[\s]*Lahir?\s*:?\s*([A-Z\s]+)[,.]?\s*(\d{2}[-\/]\d{2}[-\/]\d{4})/i;
      const birthMatch = text.match(birthPattern);

      if (birthMatch) {
        const place = birthMatch[1].trim();
        const dateStr = birthMatch[2];

        // Clean and validate place name
        let cleanPlace = place.replace(/[^A-Za-z\s]/g, '').trim();
        cleanPlace = cleanPlace.replace(/\s+/g, ' ');

        if (/^[A-Z\s]+$/i.test(cleanPlace) && cleanPlace.length >= 2 && cleanPlace.length <= 30) {
          extractedData.placeOfBirth = cleanPlace.toUpperCase();
          console.log('Found Birth Place:', cleanPlace);
        }

        // Parse and validate date
        const dateParts = dateStr.split(/[-\/]/);
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);

          // Comprehensive date validation
          if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= new Date().getFullYear()) {
            // Additional validation for reasonable birth dates
            const birthDate = new Date(year, month - 1, day);
            const currentDate = new Date();
            const age = currentDate.getFullYear() - year;

            if (birthDate <= currentDate && age >= 0 && age <= 120) {
              extractedData.birthDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
              console.log('Found Birth Date:', extractedData.birthDate);
            }
          }
        }
      }

      // Alternative birth date pattern (in case the first one doesn't match)
      if (!extractedData.birthDate) {
        const altBirthPattern = /([A-Z\s]+)[,.]?\s*(\d{2}[-\/]\d{2}[-\/]\d{4})/i;
        for (let line of lines) {
          const altMatch = line.match(altBirthPattern);
          if (altMatch && line.toLowerCase().includes('lahir')) {
            const dateStr = altMatch[2];
            const dateParts = dateStr.split(/[-\/]/);
            if (dateParts.length === 3) {
              const day = parseInt(dateParts[0]);
              const month = parseInt(dateParts[1]);
              const year = parseInt(dateParts[2]);

              if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= new Date().getFullYear()) {
                const birthDate = new Date(year, month - 1, day);
                const currentDate = new Date();
                const age = currentDate.getFullYear() - year;

                if (birthDate <= currentDate && age >= 0 && age <= 120) {
                  extractedData.birthDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
                  console.log('Found Birth Date (alternative):', extractedData.birthDate);

                  // Also try to extract place from the same line
                  if (!extractedData.placeOfBirth) {
                    let place = altMatch[1].trim();
                    place = place.replace(/[^A-Za-z\s]/g, '').trim();
                    place = place.replace(/\s+/g, ' ');

                    if (/^[A-Z\s]+$/i.test(place) && place.length >= 2 && place.length <= 30) {
                      extractedData.placeOfBirth = place.toUpperCase();
                      console.log('Found Birth Place (alternative):', place);
                    }
                  }
                  break;
                }
              }
            }
          }
        }
      }

    } catch (error) {
      console.error('Error parsing KTP data:', error);
    }

    console.log('Final extracted KTP data:', extractedData);
    return extractedData;
  };

  const handleImagePicker = async () => {
    try {
      // Request permission
      const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (permissionResult.granted === false) {
        showCustomAlert('Error', 'Izin akses galeri diperlukan untuk upload KTP');
        return;
      }

      // Launch image picker
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [4, 3],
        quality: 0.8,
        base64: true,
      });

      if (!result.canceled && result.assets[0]) {
        const asset = result.assets[0];
        // console.log('Selected image MIME type:', asset.uri);
        // const mimeType = asset.mimeType || (asset.uri.endsWith('.webp') ? 'image/webp' : 'image/jpeg');
        // console.log('Selected image MIME type:', mimeType);
        // const base64Image = `data:${mimeType};base64,${asset.base64}`;

        const base64Image = asset.uri;
        // const base64Image = `data:${asset.type || 'image/jpeg'};base64,${asset.base64}`;

        setFormData(prev => ({
          ...prev,
          identityFile: base64Image
        }));

        // Set filename for display
        const fileName = asset.fileName || `ktp_${Date.now()}.jpg`;
        setUploadedFileName(fileName);

        // Process KTP image with OCR
        // await processKTPImage(asset.uri);

        if (asset.size / 1024 / 1024 > 10) {
          setUploadedFileName('');
          showCustomAlert('Error', 'Ukuran file lebih dari batas maksimal 10MB');
          return;
        }

        await processOCRKTP(base64Image);

      }
    } catch (error) {
      console.error('Error picking image:', error);
      showCustomAlert('Error', 'Gagal memilih gambar. Silakan coba lagi.');
    }
  };

  const validateForm = () => {
    const { fullName, email, phone, nik, birthDate, placeOfBirth, password, confirmPassword, identityFile, province, city, address, gender } = formData;

    console.log('=== FORM VALIDATION START ===');
    // console.log('Form data:', formData);
    // console.log('acceptTerms:', acceptTerms);
    // console.log('ageConfirmation:', ageConfirmation);

    if (! captchaToken) {
      showCustomAlert('Error', 'Pemeriksaan keamanan gagal! Silakan muat ulang dan coba beberapa saat lagi.');
      return false;
    }

    if (!fullName.trim()) {
      console.log('VALIDATION FAILED: No full name provided');
      showCustomAlert('Error', 'Nama lengkap harus diisi');
      return false;
    }

    // Validate that at least email or phone is provided
    if (!email.trim() && !phone.trim()) {
      console.log('VALIDATION FAILED: No email or phone provided');
      showCustomAlert('Error', 'Email atau nomor HP harus diisi');
      return false;
    }

    // Validate email format if email is provided
    if (email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        console.log('VALIDATION FAILED: Invalid email format:', email);
        showCustomAlert('Error', 'Format email tidak valid');
        return false;
      }
    }

    // Validate phone format if phone is provided
    if (phone.trim()) {
      // Basic phone validation - should contain only numbers and common phone characters
      const phoneRegex = /^[\d\s\-\+\(\)]+$/;
      if (!phoneRegex.test(phone)) {
        console.log('VALIDATION FAILED: Invalid phone format:', phone);
        showCustomAlert('Error', 'Format nomor HP tidak valid');
        return false;
      }
    }

    // Validate phone format to make sure it is valid Indonesian cellular number without heading of 08/628/+628
    if (phone.length < 8 || phone.length > 13) {
      console.log('VALIDATION FAILED: Invalid phone format:', phone);
      showCustomAlert('Error', 'Format nomor handphone tidak valid');
      return false;
    }

    // Validate phone format to make sure it is valid Indonesian cellular number without heading of 08/628/+628
    if (phone.startsWith('08') || phone.startsWith('628') || phone.startsWith('+628')) {
      console.log('VALIDATION FAILED: Invalid phone format:', phone);
      showCustomAlert('Error', 'Ketikkan nomor handphone setelah "08" saja');
      return false;
    }

    if (!password.trim()) {
      console.log('VALIDATION FAILED: No password provided');
      showCustomAlert('Error', 'Password harus diisi');
      return false;
    }

    if (password.length < 8) {
      console.log('VALIDATION FAILED: Password too short:', password.length);
      showCustomAlert('Error', 'Password minimal 8 karakter');
      return false;
    }

    if (password !== confirmPassword) {
      console.log('VALIDATION FAILED: Password mismatch');
      showCustomAlert('Error', 'Konfirmasi password tidak sesuai');
      return false;
    }

    if (!acceptTerms) {
      console.log('VALIDATION FAILED: Terms not accepted');
      showCustomAlert('Error', 'Anda harus menyetujui syarat dan ketentuan');
      return false;
    }

    if (!birthDate.trim()) {
      console.log('VALIDATION FAILED: No birth date provided');
      showCustomAlert('Error', 'Tanggal lahir harus diisi');
      return false;
    }

    // Validate date format (DD-MM-YYYY)
    if (!dmyPattern.test(birthDate)) {
      console.log('VALIDATION FAILED: Invalid birth date format:', birthDate);
      showCustomAlert('Error', 'Format tanggal lahir harus DD-MM-YYYY (contoh: 15-01-1990)');
      return false;
    }

    // Validate that the date is a valid date
    const dateParts = birthDate.split('-');
    const day = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]);
    const year = parseInt(dateParts[2]);
    const date = new Date(year, month - 1, day);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      console.log('VALIDATION FAILED: Invalid birth date object:', birthDate);
      showCustomAlert('Error', 'Tanggal lahir tidak valid');
      return false;
    }

    // Validate reasonable birth date range
    const currentDate = new Date();
    const age = currentDate.getFullYear() - year;
    if (age < 0 || age > 120) {
      console.log('VALIDATION FAILED: Invalid age:', age);
      showCustomAlert('Error', 'Tanggal lahir tidak masuk akal');
      return false;
    }

    if (!province.trim()) {
      console.log('VALIDATION FAILED: No province provided');
      showCustomAlert('Error', 'Provinsi harus dipilih');
      return false;
    }

    if (!provinces.map(p => p.value).includes(province)) {
      console.log('VALIDATION FAILED: Invalid province provided');
      showCustomAlert('Error', 'Provinsi harus dipilih');
      return false;
    }

    if (!city.trim()) {
      console.log('VALIDATION FAILED: No city provided');
      showCustomAlert('Error', 'Kab/Kota harus dipilih');
      return false;
    }

    if (!cities.map(c => c.value).includes(city)) {
      console.log('VALIDATION FAILED: Invalid city provided');
      showCustomAlert('Error', 'Kab/Kota harus dipilih');
      return false;
    }

    if (!ageConfirmation) {
      console.log('VALIDATION FAILED: Age not confirmed');
      showCustomAlert('Error', `Anda harus mengkonfirmasi bahwa berusia ${minAge} tahun ke atas`);
      return false;
    }

    if (!gender.trim()) {
      console.log('VALIDATION FAILED: No gender provided');
      showCustomAlert('Error', 'Jenis kelamin harus dipilih');
      return false;
    }

    if (!['LAKI-LAKI', 'PEREMPUAN'].includes(gender.trim().toUpperCase())) {
      console.log('VALIDATION FAILED: Invalid gender provided');
      showCustomAlert('Error', 'Jenis kelamin tidak valid');
      return false;
    }

    if(isKTPRequired) {
      if (!identityFile) {
        console.log('VALIDATION FAILED: No identity file uploaded');
        showCustomAlert('Error', 'Upload KTP diperlukan');
        return false;
      }

      if (!placeOfBirth.trim()) {
        console.log('VALIDATION FAILED: No place of birth provided');
        showCustomAlert('Error', 'Tempat lahir harus diisi');
        return false;
      }

      if (!nik.trim()) {
        console.log('VALIDATION FAILED: No NIK provided');
        showCustomAlert('Error', 'NIK harus diisi');
        return false;
      }

      if (!/^\d{16}$/.test(nik)) {
        console.log('VALIDATION FAILED: Invalid NIK format:', nik, 'Length:', nik.length);
        showCustomAlert('Error', 'NIK harus 16 digit');
        return false;
      }

      if (!address.trim()) {
        console.log('VALIDATION FAILED: No address provided');
        showCustomAlert('Error', 'Alamat detail harus diisi');
        return false;
      }
    }

    console.log('=== FORM VALIDATION PASSED ===');
    return true;
  };

  const handleRegister = async () => {
    console.log('handleRegister called');
    console.log('acceptTerms:', acceptTerms);
    console.log('ageConfirmation:', ageConfirmation);
    console.log('isLoading:', isLoading);

    if (! validateForm()) {
      console.log('Form validation failed');
      return;
    }

    console.log('Form validation passed, starting registration...');
    setIsLoading(true);

    try {
      const completePhone = `08${formData.phone}` || "";

      // Prepare registration data according to updated API specification
      const registrationData = {
        email: formData.email || "",
        telp: completePhone || "",
        password: formData.password,
        fullname: formData.fullName.toUpperCase(),
        "state-term": acceptTerms,
        "state-21": ageConfirmation,
        "date-of-birth": formatDateForIdentity(formData.birthDate), // DD-MM-YYYY format

        nik: isKTPRequired ? formData.nik : null,
        'identitas-file': isKTPRequired ? formData.identityFile : null,

        "ocr-fullname": isKTPRequired ? ocrData.fullName : null,
        "ocr-date-of-birth": isKTPRequired ? formatDateForIdentity(ocrData.birthDate) : null, // DD-MM-YYYY format
        "ocr-nik": isKTPRequired ? ocrData.nik : null,
        "ocr-place-dob": isKTPRequired ? ocrData.placeOfBirth : null,
        "ocr-gender": isKTPRequired ? ocrData.gender : null,
        "ocr-province": isKTPRequired ? ocrData.province : null,
        "ocr-city": isKTPRequired ? ocrData.city : null,

        'province' : formData.province.toUpperCase(),
        'city' : formData.city.toUpperCase(),
        'address' : isKTPRequired ? formData.address : null,

        'gender' : formData.gender,
        'captcha-token': captchaToken,
      };

      console.log('Sending registration request...');

      const response = await fetch(`${API_BASE_URL}/api/sign-up`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(registrationData)
      });

      const result = await response.json();
      // console.log('Registration response:', result);

      if (result.status === 'success') {
        // Store user data if registration successful
        if (result.data && result.data.userData) {
          await AsyncStorage.setItem('userData', JSON.stringify(result.data.userData));

          // Store session data if provided
          if (result.data.userData.remember_token) {
            await AsyncStorage.setItem('remember_token', result.data.userData.remember_token);
          }
        }

        showCustomAlert(
          'Berhasil',
          result.message || 'Pendaftaran berhasil! Silakan verifikasi akun Anda.',
          'success'
        );

        // Navigate to login after a short delay
        setTimeout(() => {
          navigation.navigate('Login');
        }, 2000);
      } else {
        showCustomAlert('Error', result.message || 'Pendaftaran gagal. Silakan coba lagi.');
      }

    } catch (error) {
      console.error('Registration error:', error);
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        showCustomAlert('Error', 'Koneksi internet bermasalah. Silakan periksa koneksi Anda.');
      } else {
        showCustomAlert('Error', error.message || 'Pendaftaran gagal. Silakan coba lagi.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    // save this last page to storage, to handle failed auth callback
    await AsyncStorage.setItem('auth_caller', 'Register'); 

    setGoogleButtonClicked(true);

    const formData = new FormData();
    formData.append('login-from', "ZCLUB");
    formData.append('src-member', "mobile_app");
    formData.append('captcha-token', captchaToken);
    
    await fetch(`${API_BASE_URL}/api/auth/google/login`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'include',
      body: formData,
    })
    .then(response => response.json())
    .then(result => {
      if( !result.success ) {
        throw new Error( result.message || 'Terjadi kesalahan, silakan coba beberapa saat lagi' );
      }

      if( !!result.auth_url && URL.canParse(result.auth_url) ) {
        window.location.replace( result.auth_url );
      }
    })
    .catch(e => {
      console.log( e );
      setGoogleButtonClicked(false);
      showCustomAlert('Error', e.message || 'Terjadi kesalahan, silakan coba beberapa saat lagi');
    });
  };

  const handleFacebookLogin = async () => {
    // save this last page to storage, to handle failed auth callback
    await AsyncStorage.setItem('auth_caller', 'Register'); 

    setFacebookButtonClicked(true);

    const formData = new FormData();
    formData.append('login-from', "ZCLUB");
    formData.append('src-member', "mobile_app");
    formData.append('captcha-token', captchaToken);
    
    await fetch(`${API_BASE_URL}/api/auth/facebook/login`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'include',
      body: formData,
    })
    .then(response => response.json())
    .then(result => {
      if( !result.success ) {
        throw new Error( result.message || 'Terjadi kesalahan, silakan coba beberapa saat lagi' );
      }

      if( !!result.auth_url && URL.canParse(result.auth_url) ) {
        window.location.replace( result.auth_url );
      }
    })
    .catch(e => {
      console.log( e );
      setFacebookButtonClicked(false);
      showCustomAlert('Error', e.message || 'Terjadi kesalahan, silakan coba beberapa saat lagi');
    });
  };

  const handleAppleLogin = async () => {
    // save this last page to storage, to handle failed auth callback
    await AsyncStorage.setItem('auth_caller', 'Register'); 

    setAppleButtonClicked(true);

    const formData = new FormData();
    formData.append('login-from', "ZCLUB");
    formData.append('src-member', "mobile_app");
    formData.append('captcha-token', captchaToken);
    
    await fetch(`${API_BASE_URL}/api/auth/apple/login`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'include',
      body: formData,
    })
    .then(response => response.json())
    .then(result => {
      if( !result.success ) {
        throw new Error( result.message || 'Terjadi kesalahan, silakan coba beberapa saat lagi' );
      }

      if( !!result.auth_url && URL.canParse(result.auth_url) ) {
        window.location.replace( result.auth_url );
      }
    })
    .catch(e => {
      console.log( e );
      setAppleButtonClicked(false);
      showCustomAlert('Error', e.message || 'Terjadi kesalahan, silakan coba beberapa saat lagi');
    });
  };

  // Helper function to format date from DD-MM-YYYY or YYYY-MM-DD to DD-MM-YYYY
  const formatDateForIdentity = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    if (parts.length === 3) {
      // Check if it's already in DD-MM-YYYY format (day <= 31, month <= 12)
      if (parseInt(parts[0]) <= 31 && parseInt(parts[1]) <= 12) {
        return dateString; // Already in DD-MM-YYYY format
      }
      // Convert from YYYY-MM-DD to DD-MM-YYYY
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  };

  const loadSettings = async () => {
    setIsLoadSettings(true);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/setting`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
        body: JSON.stringify({
          "keys": [
            'CONF_SYSTEM_ZCLUB_NEED_KTP',
            'CONF_SYSTEM_MINIMUM_AGE'
          ],
        }),
      });

      const result = await response.json();
      setIsKTPRequired( result["CONF_SYSTEM_ZCLUB_NEED_KTP"] == "1" );
      setIsFieldEditable( result["CONF_SYSTEM_ZCLUB_NEED_KTP"] != "1" );
      setMinAge( result["CONF_SYSTEM_MINIMUM_AGE"] );

    } catch(e) {
      console.log(e);
      setIsKTPRequired( true );
      setMinAge( "21" )
    } finally {
      setIsLoadSettings(false);
    }
  }

  const loadProvinces = async () => {
    setIsLoadProvinces(true);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/provinces`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
      });

      const result = await response.json();
      setProvinces( result.data.map(province => {
        return {
          label: province.nama_provinsi?.toUpperCase(),
          value: province.nama_provinsi?.toUpperCase(),
        };
      }) );

    } catch(e) {
      console.log(e);
      setProvinces([])
    } finally {
      setIsLoadProvinces(false);
    }
  }

  const loadCities = async () => {
    setIsLoadCities(true);

    const provinceData = new FormData();
    provinceData.append('provinsi', formData.province);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/cities`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
        body: provinceData
      });

      const result = await response.json();
      setCities( result.data.map(city => {
        return {
          label: city.nama_kota?.toUpperCase(),
          value: city.nama_kota?.toUpperCase(),
        };
      }) );

    } catch(e) {
      console.log(e);
      setCities([])
    } finally {
      setIsLoadCities(false);
    }
  }

  useFocusEffect(
    React.useCallback(()=>{
      async function checkAuthErrorMessage() {
        const authErrorMessage = await AsyncStorage.getItem('auth_error_message');
        if( !!authErrorMessage ) {
          showCustomAlert('Error', authErrorMessage || 'Terjadi kesalahan, silakan coba beberapa saat lagi');
          await AsyncStorage.removeItem('auth_error_message');
        }
      }

      checkAuthErrorMessage();

      loadSettings();
      loadProvinces();
    }, [navigation])
  );

  useEffect(() => {
    if( isProvinceOpen ) setOpenDropdown('province');
    if( isCityOpen ) setOpenDropdown('city');
  }, [isProvinceOpen, isCityOpen]);

  // close datepicker when back button clicked
  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      if( !isDatepickerShown ) {
        return;
      }

      e.preventDefault();
      hideDatePicker();
    });

    return unsubscribe;
  }, [navigation, isDatepickerShown]);

  const [fontsLoaded] = useFonts({
    'Poppins': require('../../assets/fonts/Poppins-Regular.ttf'),
    'Poppins-Medium': require('../../assets/fonts/Poppins-Medium.ttf'),
    'Poppins-SemiBold': require('../../assets/fonts/Poppins-SemiBold.ttf'),
    'Poppins-Bold': require('../../assets/fonts/Poppins-Bold.ttf'),
  });

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <View style={styles.container}>
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.header}>
            <TouchableOpacity
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <Ionicons name="arrow-back" size={24} color="#000000" />
            </TouchableOpacity>
          </View>

          {isLoadSettings || isLoadProvinces || !fontsLoaded ? (
            <ActivityIndicator size="large" color="#1E293B" />
          ) : (
            <View style={styles.content}>
              <View style={styles.titleSection}>
                <Text style={styles.title}>Daftar</Text>
                <Text style={styles.subtitle}>
                  Buat akun dan kumpulkan hadiah-hadiah Zoolyfe!
                </Text>
              </View>

              <View style={styles.formSection}>
                {isKTPRequired && (
                  <View style={styles.formGroup}>
                    <Text style={styles.label}>Upload KTP *</Text>
                    <TouchableOpacity
                      style={[styles.uploadContainer, isProcessingOCR && styles.uploadContainerProcessing]}
                      onPress={handleImagePicker}
                      disabled={isProcessingOCR}
                    >
                      <View style={styles.uploadContent}>
                        {isProcessingOCR ? (
                          <>
                            <ActivityIndicator size="large" color="#3B82F6" />
                            <Text style={styles.uploadText}>Memindai KTP...</Text>
                            <Text style={styles.uploadSubtext}>Mohon tunggu, sedang menganalisis gambar KTP</Text>
                          </>
                        ) : (
                          <>
                            <Ionicons name="document-outline" size={24} color="#94A3B8" />
                            <Text style={styles.uploadText}>
                              {uploadedFileName || 'Upload KTP'}
                            </Text>
                            <Text style={styles.uploadSubtext}>Klik atau Tarik file ke kotak ini. Format: JPEG/PNG</Text>
                            {uploadedFileName && (
                              <Text style={styles.ocrHintText}>✨ Data akan diisi otomatis setelah upload</Text>
                            )}
                          </>
                        )}
                      </View>
                    </TouchableOpacity>
                  </View>
                )}

                <View style={styles.formGroup}>
                  <Text style={styles.label}>{isKTPRequired ? `Nama Sesuai KTP *` : `Nama Lengkap *`}</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <TextInput
                      style={styles.input}
                      placeholder={isKTPRequired ? `Nama Sesuai KTP ` : `Nama Lengkap`}
                      placeholderTextColor="#94A3B8"
                      value={formData.fullName}
                      onChangeText={(value) => handleInputChange('fullName', value)}
                      autoCapitalize="words"
                      autoCorrect={false}
                      editable={isFieldEditable}
                    />
                  </View>
                </View>

                <View 
                  style={{
                    ...styles.formGroup,
                    zIndex: 5000,
                  }}
                >
                  <Text style={styles.label}>Jenis Kelamin *</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <DropDownPicker
                      style={DropdownStyle.customStyles.dropdown}
                      textStyle={DropdownStyle.customStyles.dropdownText}
                      disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                      placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                      dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                      listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      placeholder="Jenis Kelamin"
                      searchable={false}
                      open={isGenderOpen}
                      value={formData.gender}
                      items={genders}
                      setOpen={setIsGenderOpen}
                      setItems={setGenders}
                      onSelectItem={(item) => {
                        handleInputChange('gender', item.value);
                      }}
                      disabled={!isFieldEditable}
                    />
                  </View>
                </View>

                <View style={styles.formGroup}>
                  <Text style={styles.label}>Email *</Text>
                  <View style={styles.inputContainer}>
                    <TextInput
                      style={styles.input}
                      placeholder="contoh@email.com"
                      placeholderTextColor="#94A3B8"
                      value={formData.email}
                      onChangeText={(value) => handleInputChange('email', value)}
                      keyboardType="email-address"
                      autoCapitalize="none"
                      autoCorrect={false}
                    />
                  </View>
                </View>

                <View style={styles.formGroup}>
                  <Text style={styles.label}>No. HP *</Text>
                  <View style={styles.inputContainer}>
                    <Text style={styles.inputPrefix}>08-</Text>
                    <MaskedTextInput
                      mask="999-9999999999"
                      style={styles.input}
                      placeholder="xxx-xxxxxxx"
                      placeholderTextColor="#94A3B8"
                      value={formData.phone}
                      onChangeText={(text, rawText) => {
                        handleInputChange('phone', rawText);
                      }}
                      keyboardType="phone-pad"
                      autoCorrect={false}
                    />
                  </View>
                </View>

                <View style={styles.formGroup}>
                  <Text style={styles.label}>Tanggal Lahir *</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <MaskedTextInput
                      mask="99-99-9999"
                      style={styles.input}
                      placeholder="DD-MM-YYYY"
                      placeholderTextColor="#94A3B8"
                      value={formData.birthDate}
                      onChangeText={(text, rawText) => {
                        // const dobPattern = /^\d{2}-\d{2}-\d{4}$/;
                        // if( dobPattern.test(text) ) {
                          handleInputChange('birthDate', text);
                        // }
                      }}
                      keyboardType="numeric"
                      editable={isFieldEditable}
                    />
                    <TouchableOpacity
                      style={styles.inputIcon}
                      onPress={() => handleShowDatepicker(formData.birthDate)}
                      disabled={!isFieldEditable}
                    >
                      <Ionicons
                        name="calendar-outline"
                        size={20}
                        color="#64748B"
                      />
                    </TouchableOpacity>
                  </View>
                </View>

                {isKTPRequired && (
                  <View style={styles.formGroup}>
                    <Text style={styles.label}>Tempat Lahir *</Text>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <TextInput
                        style={styles.input}
                        placeholder="Tempat lahir"
                        placeholderTextColor="#94A3B8"
                        value={formData.placeOfBirth}
                        onChangeText={(value) => handleInputChange('placeOfBirth', value)}
                        autoCapitalize="words"
                        autoCorrect={false}
                        editable={isFieldEditable}
                      />
                    </View>
                  </View>
                )}

                {isKTPRequired && (
                  <View style={styles.formGroup}>
                    <Text style={styles.label}>NIK *</Text>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <TextInput
                        style={styles.input}
                        placeholder='NIK'
                        placeholderTextColor="#94A3B8"
                        value={formData.nik}
                        onChangeText={(value) => handleInputChange('nik', value)}
                        keyboardType="numeric"
                        autoCorrect={false}
                        editable={isFieldEditable}
                      />
                    </View>
                  </View>
                )}

                <View 
                  style={{
                    ...styles.formGroup,
                    zIndex: openDropdown == 'province' ? 5001 : 5000,
                  }}
                >
                  <Text style={styles.label}>Alamat *</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <DropDownPicker
                      style={DropdownStyle.customStyles.dropdown}
                      textStyle={DropdownStyle.customStyles.dropdownText}
                      disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                      placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                      dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                      listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      searchContainerStyle={DropdownStyle.customStyles.dropdownSearch}
                      searchTextInputStyle={DropdownStyle.customStyles.dropdownSearchText}
                      searchTextInputProps={{
                        autoFocus: true,
                      }}
                      placeholder="Provinsi"
                      searchable={true}
                      open={isProvinceOpen}
                      value={formData.province}
                      items={provinces}
                      setOpen={setIsProvinceOpen}
                      setItems={setProvinces}
                      onSelectItem={(item) => {
                        handleInputChange('province', item.value);
                      }}
                      onChangeValue={async ()=>{
                        await loadCities();
                        handleInputChange('city', ocrCity);
                        if( !formData.city ) {
                          setOcrCity('');
                        }
                      }}
                      disabled={!isFieldEditable}
                    />
                  </View>
                </View>

                <View 
                  style={{
                    ...styles.formGroup,
                    zIndex: openDropdown == 'city' ? 5001 : 5000,
                  }}
                >
                  <View style={isLoadCities || !isFieldEditable || !formData.province ? styles.inputContainerDisabled : styles.inputContainer}>
                    <DropDownPicker
                      style={DropdownStyle.customStyles.dropdown}
                      textStyle={DropdownStyle.customStyles.dropdownText}
                      disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                      placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                      dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                      listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                      searchContainerStyle={DropdownStyle.customStyles.dropdownSearch}
                      searchTextInputStyle={DropdownStyle.customStyles.dropdownSearchText}
                      searchTextInputProps={{
                        autoFocus: true,
                      }}
                      placeholder="Kab/Kota"
                      searchable={true}
                      open={isCityOpen}
                      value={formData.city}
                      items={cities}
                      setOpen={setIsCityOpen}
                      setItems={setCities}
                      onSelectItem={(item) => {
                        handleInputChange('city', item.value);
                      }}
                      disabled={isLoadCities || !isFieldEditable || !formData.province}
                    />
                  </View>
                </View>

                {isKTPRequired && (
                  <View style={styles.formGroup}>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <TextInput
                        style={styles.input}
                        placeholder='Alamat Detail'
                        value={formData.address}
                        onChangeText={(value) => handleInputChange('address', value)}
                        placeholderTextColor="#94A3B8"
                        keyboardType="numeric"
                        autoCorrect={false}
                        editable={isFieldEditable}
                      />
                    </View>
                  </View>
                )}

                <View style={styles.formGroup}>
                  <Text style={styles.label}>Password *</Text>
                  <View style={styles.inputContainer}>
                    <TextInput
                      style={styles.input}
                      placeholder="Minimal 8 karakter"
                      placeholderTextColor="#94A3B8"
                      value={formData.password}
                      onChangeText={(value) => handleInputChange('password', value)}
                      secureTextEntry={!showPassword}
                      autoCapitalize="none"
                      autoCorrect={false}
                    />
                    <TouchableOpacity
                      style={styles.eyeIcon}
                      onPress={() => setShowPassword(!showPassword)}
                    >
                      <Ionicons
                        name={showPassword ? "eye-outline" : "eye-off-outline"}
                        size={20}
                        color="#64748B"
                      />
                    </TouchableOpacity>
                  </View>
                  <Text style={styles.note}>{`Minimal 8 karakter, wajib mengandung satu angka, satu huruf kapital dan satu karakter khusus`}</Text>
                </View>

                <View style={styles.formGroup}>
                  <Text style={styles.label}>Konfirmasi Password *</Text>
                  <View style={styles.inputContainer}>
                    <TextInput
                      style={styles.input}
                      placeholder="Konfirmasi password"
                      placeholderTextColor="#94A3B8"
                      value={formData.confirmPassword}
                      onChangeText={(value) => handleInputChange('confirmPassword', value)}
                      secureTextEntry={!showConfirmPassword}
                      autoCapitalize="none"
                      autoCorrect={false}
                    />
                    <TouchableOpacity
                      style={styles.eyeIcon}
                      onPress={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      <Ionicons
                        name={showConfirmPassword ? "eye-outline" : "eye-off-outline"}
                        size={20}
                        color="#64748B"
                      />
                    </TouchableOpacity>
                  </View>
                </View>

                <View style={styles.checkboxContainer}>
                  <TouchableOpacity
                    style={[styles.checkbox, ageConfirmation && styles.checkboxChecked]}
                    onPress={() => setAgeConfirmation(!ageConfirmation)}
                  >
                    {ageConfirmation && (
                      <Ionicons name="checkmark" size={16} color="#FFFFFF" />
                    )}
                  </TouchableOpacity>
                  <Text style={styles.checkboxText}>
                    {`Dengan mendaftar, saya menyatakan sudah berusia ${minAge} tahun keatas.`}
                  </Text>
                </View>

                <View style={styles.checkboxContainer}>
                  <TouchableOpacity
                    style={[styles.checkbox, acceptTerms && styles.checkboxChecked]}
                    onPress={() => setAcceptTerms(!acceptTerms)}
                  >
                    {acceptTerms && (
                      <Ionicons name="checkmark" size={16} color="#FFFFFF" />
                    )}
                  </TouchableOpacity>
                  <Text style={styles.checkboxText}>
                    Saya menyetujui {' '}
                    <Text style={styles.linkText}>Syarat & Ketentuan</Text>
                    {' '} serta  {' '}
                    <Text style={styles.linkText}>Kebijakan Privasi</Text>
                    {' '} Zoolyfe.
                  </Text>
                </View>

                <TouchableOpacity
                  style={[styles.registerButton, styles.externalAuthButton, (!acceptTerms || !ageConfirmation || isLoading) && styles.disabledButton]}
                  onPress={handleRegister}
                  disabled={!acceptTerms || !ageConfirmation || isLoading}
                >
                  <Text style={styles.registerButtonText}>
                    {isLoading ? 'Mendaftar...' : 'Daftar'}
                  </Text>
                </TouchableOpacity>

                <Text style={styles.extrenalAuthDivider}>atau masuk dengan</Text>

                <TouchableOpacity
                  style={[styles.registerButton, styles.externalAuthButton, styles.googleButton, (isLoading || googleButtonClicked) && styles.disabledButton]}
                  onPress={handleGoogleLogin}
                  disabled={isLoading || googleButtonClicked}
                >
                  <FontAwesome5 style={styles.externalAuthButtonIcon} name="google" size={14} color="#000000" />
                  <Text style={[styles.registerButtonText, styles.googleButtonText]}>Daftar dengan Google</Text>
                </TouchableOpacity>

                {/*<TouchableOpacity
                  style={[styles.registerButton, styles.externalAuthButton, styles.facebookButton, (isLoading || facebookButtonClicked) && styles.disabledButton]}
                  onPress={handleFacebookLogin}
                  disabled={isLoading || facebookButtonClicked}
                >
                  <FontAwesome5 style={styles.externalAuthButtonIcon} name="facebook" size={14} color="#FFFFFF" />
                  <Text style={styles.registerButtonText}>Daftar dengan Facebook</Text>
                </TouchableOpacity>*/}

                <TouchableOpacity
                  style={[styles.registerButton, styles.externalAuthButton, styles.appleButton, (isLoading || appleButtonClicked) && styles.disabledButton]}
                  onPress={handleAppleLogin}
                  disabled={isLoading || appleButtonClicked}
                >
                  <FontAwesome5 style={styles.externalAuthButtonIcon} name="apple" size={14} color="#FFFFFF" />
                  <Text style={styles.registerButtonText}>Daftar dengan Apple</Text>
                </TouchableOpacity>

                <View style={styles.loginContainer}>
                  <Text style={styles.loginText}>Sudah punya akun? </Text>
                  <TouchableOpacity onPress={() => navigation.navigate('Login')}>
                    <Text style={styles.loginLink}>Masuk</Text>
                  </TouchableOpacity>
                </View>

                {/* Turnstile renders only on web */}
                {Platform.OS === 'web' && (
                  <TurnstileWidget
                    siteKey={Constants.expoConfig?.extra?.TURNSTILE_SITE_KEY}
                    onVerify={(token) => setCaptchaToken(token)}
                  />
                )}
              </View>
            </View>
          )}
        </ScrollView>
      </View>

      {customAlertModal}

      {/* Date Picker Modal */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={isDatepickerShown}
        onRequestClose={hideDatePicker}
      >
        <TouchableOpacity 
          style={DatePickerStyle.modalStyles.datepickerOverlay}
          onPress={hideDatePicker}
          activeOpacity={1}
        >
          <TouchableOpacity 
            style={DatePickerStyle.modalStyles.datepickerContainer} 
            onPress={(e) => e.stopPropagation()}
            activeOpacity={1}
          >
            <View style={DatePickerStyle.modalStyles.datepickerBody}>
              <DateTimePicker
                locale="id"
                mode="single"
                maxDate={new Date()}
                date={datepickerDate}
                onChange={({ date }) => {
                  setDatepickerDate(date);
                  
                  const dateString = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
                  handleInputChange('birthDate', dateString);
                  hideDatePicker();
                }}
                styles={{
                  ...datepickerDefaultStyles,
                  ...DatePickerStyle.customStyles
                }}
              />
            </View>
            <View style={DatePickerStyle.modalStyles.datepickerFooter}>
              <TouchableOpacity
                onPress={hideDatePicker}
              >
                <Text style={DatePickerStyle.modalStyles.datepickerCancelButton}>Batal</Text>
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </TouchableOpacity>
      </Modal>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  scrollContent: {
    flexGrow: 1,
    padding: 16,
    paddingTop: 32,
  },
  header: {
    marginBottom: 32,
  },
  backButton: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
  },
  titleSection: {
    marginBottom: 32,
  },
  title: {
    fontSize: 30,
    lineHeight: 36,
    fontFamily: 'Poppins-Semibold',
    fontWeight: 600,
    color: '#00000',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: 24,
    fontFamily: 'Poppins',
    color: '#64748B',
  },
  formSection: {
    flex: 1,
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: '#374151',
    marginBottom: 8,
    fontFamily: 'Poppins-Medium',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    paddingHorizontal: 16,
    height: 48,
  },
  inputContainerDisabled: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#E2E8F0',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    paddingHorizontal: 16,
    height: 48,
  },
  input: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
    fontFamily: 'Poppins',
  },
  inputDisabled: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
    backgroundColor: '#E2E8F0',
    fontFamily: 'Poppins',
  },
  inputPrefix: {
    fontSize: 16,
    color: '#1E293B',
    fontFamily: 'Poppins',
    // marginRight: 8,
  },
  eyeIcon: {
    padding: 4,
  },
  inputIcon: {
    marginLeft: 8,
  },
  uploadContainer: {
    borderWidth: 1,
    borderColor: '#94A3B8',
    borderStyle: 'dashed',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: 136,
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadContent: {
    alignItems: 'center',
    width: 208,
  },
  uploadText: {
    fontSize: 14,
    color: '#1E293B',
    marginTop: 8,
    fontWeight: '600',
    fontFamily: 'Poppins',
    textAlign: 'center',
  },
  uploadSubtext: {
    fontSize: 12,
    color: '#94A3B8',
    marginTop: 4,
    fontFamily: 'Poppins',
    textAlign: 'center',
    lineHeight: 16,
  },
  uploadContainerProcessing: {
    borderColor: '#3B82F6',
    backgroundColor: '#F0F9FF',
  },
  ocrHintText: {
    fontSize: 11,
    color: '#3B82F6',
    marginTop: 6,
    fontFamily: 'Poppins',
    textAlign: 'center',
    fontWeight: '500',
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
    marginTop: 2,
  },
  checkboxChecked: {
    backgroundColor: '#000000',
    borderColor: '#000000',
  },
  checkboxText: {
    flex: 1,
    fontSize: 12,
    color: '#374151',
    lineHeight: 16,
    fontFamily: 'Poppins',
  },
  linkText: {
    color: '#3B82F6',
    fontWeight: '500',
  },
  registerButton: {
    backgroundColor: '#000000',
    borderRadius: 6,
    padding: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  disabledButton: {
    opacity: 0.7,
  },
  registerButtonText: {
    fontFamily: 'Poppins-Medium',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 20,
    color: '#FFFFFF',
  },
  extrenalAuthDivider: {
    width: '100%', 
    textAlign: 'center', 
    fontSize: 12, 
    fontFamily: 'Poppins', 
    color: '#94A3B8',
    marginBottom: 16,
  },
  externalAuthButton: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 16,
  },
  externalAuthButtonIcon: {
    width: 14, 
    justifyContent: 'center',
  },
  googleButton: {
    backgroundColor: '#FFFFFF',
    borderColor: '#9CA3AF',
    borderWidth: 1,
  },
  googleButtonText: {
    color: '#000000',
  },
  facebookButton: {
    backgroundColor: '#2563eb',
  },
  appleButton: {
    backgroundColor: '#0f172a',
  },
  loginContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginText: {
    fontSize: 14,
    fontFamily: 'Poppins',
    fontWeight: 400,
    color: '#64748B',
  },
  loginLink: {
    fontSize: 14,
    fontFamily: 'Poppins-Semibold',
    fontWeight: 600,
    color: '#1E293B',
  },
  note: {
    fontFamily: 'Poppins',
    fontSize: 12,
    color: '#94A3B8',
    marginTop: 6
  },
  
});
